<div class="modal-dialog" role="document">
  <div class="modal-content bd-0">
    <div class="modal-header pd-y-20 pd-x-25">
      <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{ data.title | translate }}</h6>
      <button type="button" class="btn-close" (click)="dialogRef.close(false);" aria-label="Sluiten"></button>
    </div>
    <div class="modal-body p-5">
      <div class="mg-b-5">
        <div><b>{{ headerText }}</b></div>
        <br />
        @for (line of lines; track $index) {
          <div [class.upload-message-line--warning]="data.isWarning" [class.upload-message-line--error]="!data.isWarning">
            <span><i class="fas" [ngClass]="data.isWarning ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'"></i>&nbsp;{{ line }}</span>
          </div>
          <br />
        }
      </div>
    </div>

    <div class="modal-footer">
      <div class="col-6">
        @if (data.cancelonly.valueOf() === false) {
          <button type="button" class="btn btn-block btn-primary" (click)="dialogRef.close(true)">{{ 'BTN.OK' | translate }}</button>
        }
      </div>
      <div class="col-6">
        @if (data.okonly.valueOf() === false) {
          <button type="button" class="btn btn-block btn-secondary" (click)="dialogRef.close(false);">{{ 'BTN.CANCEL' | translate }}</button>
        }
      </div>
    </div>

  </div>
</div>
